import PropTypes from "prop-types";
import React from "react";

import FormGridOptionsPicker from "./FormGridOptionsPicker";

class FormColorPicker extends React.Component {
  constructor(props) {
    super(props);
  }

  renderOption(opt, selectedValue, onOptionClick, ref) {
    const selected = selectedValue === opt;
    return (
      <div
        ref={ref}
        className={`colorPickerOption ${opt} ${selected ? "selected" : ""}`}
        key={opt}
        onClick={onOptionClick}
      />
    );
  }

  renderControl(value) {
    return <div className={`colorPickerSwatch ${value}`} />;
  }

  render() {
    return (
      <FormGridOptionsPicker
        {...this.props}
        classNamePrefix="colorPicker"
        controlRenderer={this.renderControl}
        optionRenderer={this.renderOption}
      />
    );
  }
}

FormColorPicker.propTypes = {
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  id: PropTypes.string.isRequired,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  title: PropTypes.string,
  backText: PropTypes.string
};

export default FormColorPicker;
